import { render, staticRenderFns } from "./StandardLabel.vue?vue&type=template&id=7bf47f3f"
import script from "./StandardLabel.vue?vue&type=script&lang=js"
export * from "./StandardLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports